import React, { useEffect } from 'react';
import { Typography, IconButton, useMediaQuery, useTheme } from '@mui/material';
import Select from 'react-select';
import GridViewIcon from '@mui/icons-material/GridView';
import SplitscreenIcon from '@mui/icons-material/Splitscreen';
import ArrowForward from '@mui/icons-material/ArrowForwardIos';

import { useStylesModalOffer } from './hooks/useStyles';
import { useFormatMessage } from '../../../../../hooks';
import { IProduct } from '../../../../../interfaces/product';
import PaginationDots from './PaginationDots';

const selectStyles = {
  container: (provided: any) => ({
    ...provided,
    width: '100%',
    maxWidth: 320,
  }),
  menu: (provided: any, state: any) => ({
    ...provided,
    zIndex: 999,
    display: state.selectProps.isSearchable ? provided.display : 'none',
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    borderColor: state.isFocused ? '#205373' : '',
    backgroundColor: '#f5f8fa',
    border: 'none !important',
    opacity: state.isDisabled ? 0.5 : 1,
    boxShadow: state.isFocused ? '0 0 0 1px #205373 !important' : '',
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    fontSize: 14,
    backgroundColor: state.isSelected ? '#205373' : '#fff',
    color: state.isSelected ? '#fff' : '#181c32',
  }),
  singleValue: (provided: any) => ({
    ...provided,
    color: '#181c32',
    fontSize: 14,
    fontWeight: 400,
  }),
  placeholder: (provided: any) => ({
    ...provided,
    fontSize: 14,
    fontWeight: 400,
  }),
  dropdownIndicator: (provided: any, state: any) => ({
    ...provided,
    display: state.selectProps.isSearchable ? provided.display : 'none',
  }),
};

const optionsSort = [
  { label: 'По самой низкой цене за 1 шт.', value: 'priceUp' },
  { label: 'Больше всего на складе', value: 'stockQuantity' },
  { label: 'Больше всего под заказ', value: 'orderQuantity' },
  { label: 'Самая быстрая доставка под заказ', value: 'deliveryPeriod' },
];

export function HeaderOfferForBuyer({
  viewType,
  product,
  setSort,
  sort,
  setCurrentPage,
  currentPage,
  setViewType,
  perPage,
}: {
  viewType: 'grid' | 'table';
  product: IProduct;
  setSort: ({ value, label }: { value: string; label: string }) => void;
  sort: { label: string; value: string };
  setCurrentPage: (currentPage: number) => void;
  currentPage: number;
  setViewType: (viewType: 'grid' | 'table') => void;
  perPage: number;
}) {
  const fm = useFormatMessage();
  const { classes } = useStylesModalOffer();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const isTablet = useMediaQuery('(max-width:1024px)');

  const numberOfPages = product.prices_values
    ? Math.ceil(product.prices_values.length / perPage)
    : 0;

  useEffect(() => {
    if (isTablet) {
      setViewType('grid');
    }
  }, [isTablet]);

  return (
    <div
      className={classes.offerHeader}
      style={{
        flexDirection: isMobile ? 'column' : 'row',
        alignItems: isMobile ? 'flex-start' : 'center',
        gap: isMobile ? 12 : 0,
      }}
    >
      <div
        className={classes.containerTitle}
        style={{
          flexWrap: isTablet ? 'wrap' : 'nowrap',
          alignItems: isTablet ? 'flex-start' : 'center',
          gap: isTablet ? 8 : 16,
          width: isTablet ? '100%' : 'auto',
          justifyContent: 'space-between',
        }}
      >
        <Typography
          className={classes.titlePrices}
          component='p'
          style={{
            fontSize: isMobile ? 16 : 20,
            maxWidth: isMobile ? '100%' : 'auto',
            width: isMobile ? '100%' : 'auto',
          }}
        >
          Предложения от поставщиков
        </Typography>
        {product.prices_values?.[0] && (
          <Select
            placeholder={fm('ORDER.FILTER.PLACEHOLDER')}
            components={{ IndicatorSeparator: () => null }}
            value={sort}
            styles={{
              ...selectStyles,
              container: (provided: any) => ({
                ...provided,
                width: '100%',
                maxWidth: isTablet ? '100%' : 320,
              }),
            }}
            onChange={item => {
              if (item) setSort(item);
            }}
            // @ts-ignore
            options={optionsSort}
          />
        )}
      </div>
      {numberOfPages > 1 && (
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: isMobile ? 'flex-start' : 'center',
            gap: 12,
            marginTop: isMobile ? 8 : 0,
          }}
        >
          <div
            className={classes.btnArrow}
            onClick={() => setCurrentPage(currentPage === 0 ? 0 : currentPage - 1)}
          >
            <ArrowForward className={classes.iconBack} />
          </div>
          <div
            className={classes.btnArrow}
            onClick={() =>
              setCurrentPage(
                currentPage === numberOfPages - 1 ? numberOfPages - 1 : currentPage + 1
              )
            }
          >
            <ArrowForward />
          </div>
          <PaginationDots
            totalPages={numberOfPages}
            currentPage={currentPage}
            onPageChange={setCurrentPage}
          />
        </div>
      )}
      {!isTablet && (
        <div
          className={classes.containerViewType}
          style={{
            marginTop: isMobile ? 8 : 0,
            justifyContent: isMobile ? 'flex-start' : 'flex-end',
            width: isMobile ? '100%' : 'auto',
          }}
        >
          <IconButton
            onClick={() => {
              setCurrentPage(0);
              setViewType('table');
            }}
            style={{
              color: viewType === 'table' ? '#006997' : '#7c97c0',
              height: 40,
            }}
          >
            <SplitscreenIcon style={{ width: 21, height: 21 }} />
          </IconButton>
          <IconButton
            onClick={() => {
              setCurrentPage(0);
              setViewType('grid');
            }}
            style={{
              color: viewType === 'grid' ? '#006997' : '#7c97c0',
              height: 40,
            }}
          >
            <GridViewIcon style={{ width: 25, height: 25 }} />
          </IconButton>
        </div>
      )}
    </div>
  );
}
